/** True when the session allows multiple full play-throughs (from login / stored userData). */
export function isMultiplaySessionEnabled(userLike) {
  if (!userLike || typeof userLike !== 'object') return false;

  const candidates = [
    userLike.isMultiplaySession,
    userLike.is_multiplay_session,
    userLike.multiplaySession,
    userLike.session?.isMultiplaySession,
    userLike.session?.is_multiplay_session,
    userLike.gameSession?.isMultiplaySession,
  ];

  for (const v of candidates) {
    if (v === true || v === 1) return true;
    const s = String(v ?? '').trim().toLowerCase();
    if (s === 'true' || s === '1' || s === 'yes') return true;
  }
  return false;
}
